import React, { useState } from "react";
import styles from "./styles.module.scss";
import { TaskCard } from "../TaskCard";
import { Task } from "..";

export interface GoalCardProps {
  stepsData: Task[];
  onToggleSubtask: (taskId: number, subtaskId: number) => void;
}

export const GoalCard: React.FC<GoalCardProps> = ({
  stepsData,
  onToggleSubtask,
}) => {
  const [openTasks, setOpenTasks] = useState<Record<number, boolean>>({});

  const sortedTasks = [...stepsData].sort((a, b) =>
    a.status === "new" && b.status === "done" ? -1 : 1,
  );

  const handleToggle = (taskId: number) => {
    setOpenTasks((prev) => ({ ...prev, [taskId]: !prev[taskId] }));
  };

  return (
    <div className={styles.goalCardContainer}>
      {sortedTasks.map((task, index) => {
        const isTaskDone = task.status === "done";
        const completedSubtasks = task.subtasks.filter(
          (s) => s.completed,
        ).length;
        const isOpen = openTasks[task.id] || false;
        return (
          <React.Fragment key={task.id}>
            <TaskCard
              task={task}
              isTaskDone={isTaskDone}
              completedSubtasks={completedSubtasks}
              isOpen={isOpen}
              onToggle={() => handleToggle(task.id)}
              onToggleSubtask={(subtaskId: number) =>
                onToggleSubtask(task.id, subtaskId)
              }
            />
            {index < sortedTasks.length - 1 &&
              task.status === "new" &&
              sortedTasks[index + 1].status === "done" && (
                <div className={styles.newDoneDivider} />
              )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
